<template>
  <div>
    <p class="text-md font-semibold text-center">Confirmation</p>
    <UDivider class="py-4" />
    <div class="flex flex-col gap-4">
      <p> {{ title }}</p>
    </div>
    <div class="inline-flex justify-between w-full p-5">
      <div class="">
        <UButton size="xl" label="Close" variant="outline" block @click="handleClose" />
      </div>
      <div class="">
        <UButton size="xl" label="Proceed" block @click="handleProceed" />
      </div>
    </div>
  </div>

</template>
<script setup>
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventParameter } from '~/google_analytics/events.enum';
const emit = defineEmits(['close', 'success']);

const title = 'Your location has changed. Would you like to update your current location?';

onMounted(() => {
  GoogleAnalytics.popUpView({
    [EventParameter.POP_UP_NAME]: 'location_change_confirmation_popup',
    [EventParameter.POP_UP_TITLE]: title
  });
});

const handleClose = () => {
  GoogleAnalytics.popUpClick({
    [EventParameter.POP_UP_NAME]: 'location_change_confirmation_popup',
    [EventParameter.POP_UP_TITLE]: title,
    [EventParameter.POP_UP_CTA_NAME]: 'Close'
  });
  emit('close');
};

const handleProceed = () => {
  GoogleAnalytics.popUpClick({
    [EventParameter.POP_UP_NAME]: 'location_change_confirmation_popup',
    [EventParameter.POP_UP_TITLE]: title,
    [EventParameter.POP_UP_CTA_NAME]: 'Proceed'
  });
  emit('success');
};

</script>